import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { convertObjectToString, format } from 'app/shared/utils/string.util';

import { TabularTypeDataset, IModel, IViolation, IValidationContext, AdapterContext, IAttribute } from 'shell-models-lib';
import { ModelUtilties } from '../services/model-utilities';
import { LoggerService } from 'app/logger/logger.service';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { shouldValidateDeltaTableFormat } from 'app/shared/utils/databricks-dataset.util';
import { AzureDatabricksDeltaLakeLinkedService } from '../linkedservice/azure-databricks-deltalake.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.azureDatabricksDeltaLake.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureDatabricksDeltaLake_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureDatabricksDeltaLake_DisplayText)
    ],
    validator: AzureDatabricksDeltaLakeDataset.validateTable,
    constraints: {
        linkedService: {
            model: AzureDatabricksDeltaLakeLinkedService.MODEL
        }
    }
})
export class AzureDatabricksDeltaLakeDataset extends TabularTypeDataset {
    public static readonly className = 'AzureDatabricksDeltaLakeDataset';
    public static readonly MODEL: IModel;
    public static readonly DATABASE: IAttribute;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }

    @Metamodel.attribute({
        display: stringResources.DataBricks_Cluster_Unity_Catalog,
        templatable: true,
        association: 'DATABASE',
    })
    public database?: string;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static async validateTable(
        dataset: AzureDatabricksDeltaLakeDataset,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        if (
            shouldValidateDeltaTableFormat(adfModelTypeMap.azureDatabricksDeltaLake.datasetType) &&
            dataset.linkedService != null &&
            !dataset.linkedService.parameterized &&
            !TabularTypeDataset.TABLE.templateValue(dataset) &&
            !TabularTypeDataset.SCHEMA.templateValue(dataset) &&
            !!dataset.schema &&
            !!dataset.table
        ) {
            try {
                const tableFormat = await // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ((await getServiceInstance(context.contextData, 'QueryApiFactoryService')) as any)
                    .getMadridQueryApi()
                    .getTableTypeAsync(
                        dataset.linkedService,
                        await ModelUtilties.toResource(AdapterContext.defaultContextOf(context.contextData), dataset)
                    );
                if (tableFormat && tableFormat !== 'delta') {
                    return [
                        {
                            context: dataset,
                            message: () => stringResources.SelectedTableIsNotDelta,
                            doNotAutomaticallyCorrect: true
                        }
                    ];
                }
            } catch (e) {
                const logger = await getServiceInstance<LoggerService>(context.contextData, 'LoggerService');
                logger.error(AzureDatabricksDeltaLakeDataset.className, convertObjectToString(e));
            }
        }
        return undefined;
    }
}
